"use client";
import Dashboard from "@/Components/Dashboard/Dashboard";

const MainDashboard = () => {
  return (
    <>
      <Dashboard />
    </>
  );
};

export default MainDashboard;
